import { defineMessages } from 'react-intl'

const scope = `procurify.core.components.WithApprovalPoolTooltip`

export default defineMessages({
  heading: {
    id: `${scope}.heading`,
    defaultMessage: 'Requires approval from any member of this level:',
  },
  andMore: {
    id: `${scope}.andMore`,
    defaultMessage: 'and {count} more...',
  },
})
